import * as Yup from "yup";

export const eventRoleFormValidationSchema = Yup.object().shape({
  event_role: Yup.string().trim().required("Required"),
  assigned_to: Yup.string().required("Required"),
});
